import React from 'react';
import { PRESETS } from '../../utils/dateRanges';

/**
 * Pills para seleccionar preset de rango de fechas.
 *
 * Props:
 *  - active: clave del preset activo ('today' | '7d' | 'month' | 'lastMonth' | 'custom')
 *  - onChange: (key) => void
 */
export default function DateRangePresets({ active, onChange }) {
  return (
    <div className="flex flex-wrap items-center gap-2">
      {PRESETS.map((p) => {
        const isActive = active === p.key;
        return (
          <button
            key={p.key}
            type="button"
            onClick={() => onChange(p.key)}
            className={`px-3 py-1.5 rounded-full text-xs font-semibold border transition-colors ${
              isActive
                ? 'bg-purple text-bg border-purple'
                : 'bg-surface text-ink-2 border-line hover:bg-surface-2 hover:text-ink'
            }`}
          >
            {p.label}
          </button>
        );
      })}
    </div>
  );
}
